import React, { useEffect, useState } from "react";
import {
  Tabs,
  Input,
  Row,
  Col,
  Card,
  Tag,
  Dropdown,
  Button,
  Space,
} from "antd";
import { MoreOutlined, CheckCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import ProductGroupCard from "./ProdGroupCard.js";
import "../../config";

const { TabPane } = Tabs;
const { Search } = Input;

const ProductGroups = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [activeTab, setActiveTab] = useState("All");
  const [productGroup, setProductGroup] = useState([]);

  useEffect(() => {
    getListofProductGroup();
  }, [productGroup.GroupName]);

  const filteredProducts = productGroup.filter(
    (product) =>
      (activeTab === "All" || product.IsActive === true) &&
      product.GroupName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  async function getListofProductGroup() {
    const tokenString = localStorage.getItem("token");

    try {
      const listData = {
        FirmID: "1",
      };

      let config = {
        method: "get",

        url:
          global.config.APIURL.BaseURL + "api/ProductGroup/ListofProductGroup",
        headers: {
          Authorization: "Bearer " + tokenString,
        },
        data: listData,
      };

      axios
        .request(config)
        .then((response) => {
          //console.log(JSON.stringify(response.data));
          setProductGroup(response.data);
        })
        .catch((error) => {});
    } catch (err) {}
  }

  return (
    <div style={{ padding: 24 }}>
      <Card>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 24,
            flexWrap: "wrap",
            gap: 16,
          }}
        >
          <Search
            placeholder="Search products..."
            onSearch={(value) => setSearchTerm(value)}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ maxWidth: 300 }}
            allowClear
          />
        </div>

        <Row gutter={[16, 16]} justify="center">
          {filteredProducts.map((product) => (
            <Col key={product.id} xs={24} sm={12} md={8} lg={6}>
              <ProductGroupCard product={product} key={product.GroupID} />
            </Col>
          ))}
        </Row>
      </Card>
    </div>
  );
};

export default ProductGroups;
